export default __webpack_public_path__ + "static/media/careers_banner.2c2f5e95.png";